import React from 'react';

/* eslint-disable */

var twitterIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("path", {
    d: "M4.402944,11.377968 C9.686152,11.377968 12.575304,7.000952 12.575304,3.205552 C12.575304,3.081176 12.572784,2.95736 12.567128,2.834216 C13.127912,2.428832 13.615392,1.922984 14,1.347024 C13.48536,1.575616 12.931464,1.729728 12.35052,1.799224 C12.943504,1.44368 13.39884,0.880992 13.613544,0.210336 C13.058416,0.539336 12.443984,0.77868 11.789736,0.90748 C11.265576,0.349216 10.519096,0 9.693096,0 C8.106728,0 6.820352,1.286376 6.820352,2.872128 C6.820352,3.097584 6.845608,3.316712 6.894888,3.527048 C4.507776,3.40704 2.39092,2.264024 0.974456,0.526064 C0.727552,0.950432 0.585424,1.44368 0.585424,1.969744 C0.585424,2.966264 1.09256,3.845968 1.863624,4.360608 C1.392496,4.346104 0.949816,4.216632 0.562688,4.001256 C0.562072,4.01324 0.562072,4.02528 0.562072,4.03788 C0.562072,5.429144 1.552264,6.590472 2.866472,6.85384 C2.625224,6.919472 2.371376,6.95492 2.109296,6.95492 C1.924216,6.95492 1.744232,6.936552 1.569344,6.903064 C1.934968,8.044232 2.995272,8.874656 4.25264,8.898064 C3.269336,9.668512 2.030952,10.1276 0.685216,10.1276 C0.453432,10.1276 0.22484,10.114328 0,10.087784 C1.271256,10.902472 2.780568,11.377968 4.402944,11.377968"
  }));
});

export default twitterIcon;
